import { connect } from 'react-redux';

import { getConvo } from '../selectors/conversation';
import { getSettings } from '../selectors/settings';
import { RootState } from '../typedefs/store';
import App from './App';

const mapStateToProps = (state: RootState) => {
    const settings = getSettings(state);
    const { active, starting, ended, hidden, startError } = getConvo(state);
    return {
        showMessagePanel: !startError && (active || starting || ended),
        showCta: !startError && !(active || starting) && !ended && !settings.hideCta,
        showLeaveMessagePanel: startError,
        isBootstrapped: settings.bootstrapped && settings.settingsFetched,
        messageListType: settings.messageListType,
        hidden,
        zIndex: settings.zIndex,
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/AppContainer.tsx